import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

import imageMcp from '@/assets/tjxq-image-mcp.png';
import { useSieMethods } from '@/hooks/use-sie';

import styles from './brand-content.module.scss';

type Props = {
  readonly className?: string;
};

const CustomContent = ({ className }: Props) => {
  const { customContent } = useSieMethods();
  const { pathname } = useLocation();

  const customHtml = customContent?.[pathname];

  if (!customHtml) {
    return (
      <section
        aria-labelledby="tjxq-auth-brand-title"
        className={classNames(className, styles.brandPanel)}
      >
        <div className={styles.brandHeader}>
          <span className={styles.brandMark}>TJXQ</span>
          <span className={styles.brandKicker}>远程生图 · MCP</span>
        </div>
        <h1 id="tjxq-auth-brand-title">让 AI 把想法直接变成图片</h1>
        <p className={styles.brandCopy}>
          注册账户，下载一份专属配置文档，把它交给当前设备上的 AI Agent，即可完成全局配置。
        </p>
        <ul className={styles.featureList}>
          <li>
            <strong>标准 MCP</strong>
            <span>支持远程 Streamable HTTP</span>
          </li>
          <li>
            <strong>多种 Agent</strong>
            <span>Codex、Claude Code、OpenClaw、Trae、Workbuddy、DeepSeek Harness</span>
          </li>
          <li>
            <strong>账户可控</strong>
            <span>注册即获 0.5 元体验额度，设备密钥可撤销</span>
          </li>
        </ul>
        <figure className={styles.brandMedia}>
          <img alt="TJXQ 远程生图工作场景" src={imageMcp} />
          <figcaption>一次配置，图片直接回到你的 AI 对话</figcaption>
        </figure>
      </section>
    );
  }

  try {
    // Expected error; CustomContent content is load from Logto remote server
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: customHtml }} className={className} />;
  } catch {
    return null;
  }
};

export default CustomContent;
